export default __webpack_public_path__ + "static/media/p12.be7c794f.jpeg";